// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".digital-transform[data-v-1bae99df]{display:inline-flex}.digital-transform-item[data-v-1bae99df]{display:inline-block;transition:opacity .3s,transform .3s}.vdt-slide-y-enter[data-v-1bae99df],.vdt-slide-y-leave-to[data-v-1bae99df]{opacity:0;transform:translateY(10px)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
